import { useMemo } from 'react';
import { fetchInternalLink } from '@lib/fetchInternalLink';
import { useTrackCTA } from '../CtaClick/TrackCtaClick';

interface Cta {
  url?: string | null;
  buttonText: string;
  type: string;
  internalEndpoint?: string;
}

export const useCtaBlankExternalTracking = () => {
  const trackCTA = useTrackCTA();

  return useMemo(
    () => (cta: Cta) => async (e: React.MouseEvent<HTMLAnchorElement> & { target: { href?: string } }) => {
      const resolvedUrl = cta.url || e.currentTarget?.href || e.target?.href;

      if (resolvedUrl) {
        trackCTA({
          cta_position: 'content',
          text: cta.buttonText,
          url: resolvedUrl,
        });
      }

      if (cta.type === 'InternalEndpoint') {
        if (!cta.internalEndpoint) {
          return true;
        }

        e.preventDefault();
        const windowReference = window.open('', '_blank');

        try {
          const link = await fetchInternalLink(cta.internalEndpoint);
          if (windowReference) {
            windowReference.location.href = link;
          } else {
            window.open(link, '_blank');
          }
        } catch (error) {
          if (resolvedUrl) {
            if (windowReference) {
              windowReference.location.href = resolvedUrl;
            } else {
              window.open(resolvedUrl, '_blank');
            }
          }
        }

        return false;
      }

      return true;
    },
    [trackCTA],
  );
};
